import { register } from "async-ops";
import { callMvcApi  } from "../../../call-web-api";
import { getDefaultOptions } from "../../../utils/fetch";
export const GET_ATTACHMENT_LEVEL_LIST = 'GET_ATTACHMENT_LEVEL_LIST';


export const service = async (data) => {
  const options: object = {
    url:  "/Api/UserTasks/GetAttachmentLevelList",
    method: "GET",
    contentType: 'application/json'
  }
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_ATTACHMENT_LEVEL_LIST, service, mock);
